<script lang="ts">
	import { NewsletterForm } from '#lib/features/newsletter/components/NewsletterForm/index.js';
	import type { NewsletterProvenance } from '#lib/features/newsletter/constants/mixpanel-events.js';
	import { Container } from '$global/components/Container';
	import { Txt } from '$global/components/Txt';

	interface Props {
		title: string;
		intro: string;
		provenance: NewsletterProvenance;
		listId: number | number[];
		dataCy: string;
	}

	let { title, intro, provenance, listId, dataCy }: Props = $props();
</script>

<Container {dataCy} class="pb-20">
	<div
		class="grid w-full gap-4 rounded-md border border-gray-200 bg-gray-50 px-6 py-6 md:grid-cols-[minmax(0,1fr)_minmax(320px,1fr)] md:items-center md:gap-8 md:px-8 md:py-8"
	>
		<div>
			<Txt dataCy={`${dataCy}-title`} variant="h4" class="pb-2">{title}</Txt>
			<Txt dataCy={`${dataCy}-intro`} variant="body1" class="text-gray-600"
				>{intro}</Txt
			>
		</div>
		<div class="w-full">
			<NewsletterForm
				isHeniNewsletter={false}
				{provenance}
				variant="light"
				{listId}
				fullWidthInput
				classes={{ subscribeHelperText: 'mt-2' }}
			/>
		</div>
	</div>
</Container>
